var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_800_108335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_800_108335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.56246 12.0624L6.54163 9.04159C6.49996 8.99992 6.46871 8.95478 6.44788 8.90617C6.42704 8.85756 6.41663 8.80547 6.41663 8.74992C6.41663 8.63881 6.45482 8.54159 6.53121 8.45825C6.6076 8.37492 6.70829 8.33325 6.83329 8.33325H13.1666C13.2916 8.33325 13.3923 8.37492 13.4687 8.45825C13.5451 8.54159 13.5833 8.63881 13.5833 8.74992C13.5833 8.7777 13.5416 8.87492 13.4583 9.04159L10.4375 12.0624C10.368 12.1319 10.2986 12.1805 10.2291 12.2083C10.1597 12.236 10.0833 12.2499 9.99996 12.2499C9.91663 12.2499 9.84024 12.236 9.77079 12.2083C9.70135 12.1805 9.6319 12.1319 9.56246 12.0624Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.58ec6121ddfa44930397a92465ede02c.svg";
export { ForwardRef as ReactComponent };